import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { SyncStatus } from 'types/Source';

function useSyncInfo(
  syncStatus: SyncStatus,
): {
  lastSyncDate: string;
  lastSyncInfo: any;
  lastSyncStatus: string;
  timeSinceLastSync: string;
  syncRunning: boolean;
  syncHasRun: boolean;
  hasSyncErrors: boolean;
  errorMessage: string;
} {

  const currentSyncStatus = _get(syncStatus, ['currentSyncStatus', 'status']);
  const syncRunning = currentSyncStatus !== undefined;

  const lastSyncInfo = _get(syncStatus, 'lastSyncStatus');
  const completedAt = _get(lastSyncInfo, 'completedAt');
  const startedAt = _get(lastSyncInfo, 'startedAt');
  const lastSyncStatus = _get(lastSyncInfo, 'status');
  const _lastSyncDate = completedAt || startedAt;
  const lastSyncDate = _lastSyncDate && moment(_lastSyncDate).format('MM/DD/YYYY [at] hh:mm A');
  const timeSinceLastSync = _lastSyncDate && moment(_lastSyncDate).fromNow();
  const errorMessage = _get(lastSyncInfo, ['error', 'messageTxt']);
  const hasSyncErrors = lastSyncStatus === 'error';

  const syncHasRun = !_isEmpty(currentSyncStatus) || !_isEmpty(lastSyncStatus);

  return {
    lastSyncDate,
    lastSyncInfo,
    lastSyncStatus,
    timeSinceLastSync,
    syncRunning,
    syncHasRun,
    hasSyncErrors,
    errorMessage,
  };
}

export default useSyncInfo;
